import { useState } from 'react';
import EntityInfoDrawer from './EntityInfoDrawer';
import { ProfilePicture } from './ProfilePicture';
import { SpeakerPreferenceRow } from './SettingsPreferenceComponents';
import { useEntityPreference } from './useEntityPreference';
import { canOpenSpeakerProfile, displaySpeakerName, displaySpeakerDescription } from './speakerHelper';
import { SPEAKER_ROW_PIC_SIZE } from '../constants/sizes';
import './SpeakerRow.css';

export default function SpeakerRow({
    speaker,
    onSpeakerClick,
    profileBackLabel,
    showSubscribe = true,
    variant = 'preference',
    imageTextSpacing = '12px',
}) {
    const [open, setOpen] = useState(false);
    const preference = useEntityPreference('speaker', speaker);
    const canOpenProfile = canOpenSpeakerProfile(speaker);
    const name = displaySpeakerName(speaker);
    const description = displaySpeakerDescription(speaker);
    const MetadataContainer = canOpenProfile ? 'button' : 'div';
    const openSpeaker = () => {
        if (!canOpenProfile) return;
        if (onSpeakerClick) {
            onSpeakerClick(speaker);
        } else {
            setOpen(true);
        }
    };

    return <div className="entityPreferenceRowContainer">
        {canOpenProfile && <EntityInfoDrawer open={open} onClose={() => setOpen(false)}
            backLabel={profileBackLabel} speakerId={speaker.id} />}
        {variant === 'metadata' ? <MetadataContainer
            type={canOpenProfile ? 'button' : undefined}
            className='speakerMetadataRow clampSafeButton'
            style={{ gap: imageTextSpacing }}
            aria-label={canOpenProfile ? name : undefined}
            onClick={canOpenProfile ? openSpeaker : undefined}>
            <ProfilePicture speakerId={speaker.id} imageSrc={speaker.imageURL}
                anonymousDisplay={speaker.anonymousDisplay} imageLabel={name}
                followed={preference.status === true}
                size={SPEAKER_ROW_PIC_SIZE} />
            <div className='speakerMetadataText'>
                <div className='speakerNameSmall'>{name}</div>
                {description && <div className='speakerDescription'>{description}</div>}
            </div>
        </MetadataContainer> : <SpeakerPreferenceRow speaker={{ ...speaker, name }} description={description}
            status={preference.status}
            showControl={canOpenProfile && showSubscribe}
            onOpen={canOpenProfile ? openSpeaker : undefined}
            onStatusChange={preference.change} />}
    </div>;
}
